export const CANVAS_ACTIVE_WIDGET_MODES = [
    "selected",
    "editing",
    "dragging",
];
/** The format a presenter view's `screen` must have (not exported: the
 *  collab contract hashes this barrel's names). */
const PRESENTER_SCREEN = /^[a-z0-9-]{1,32}$/;
/** The largest area a presenter can see: a wide screen at the lowest zoom,
 *  with room to spare (not exported, as above). */
const PRESENTER_AREA_MAX = 400_000;
export const VSM_PRESENTER_VIEWPORT_MIN = -16_000;
export const VSM_PRESENTER_VIEWPORT_MAX = 76_000;
export const VSM_PRESENTER_ZOOM_MIN = 0.05;
export const VSM_PRESENTER_ZOOM_MAX = 1.5;
/** Rejects extra keys and values outside the interactive VSM map extent. The
 *  optional keys are `screen`, checked for format only, and `width` with
 *  `height`, both or neither. */
export function parseCanvasPresenterViewport(input) {
    if (typeof input !== "object" ||
        input === null ||
        Array.isArray(input) ||
        Object.getPrototypeOf(input) !== Object.prototype) {
        throw new Error("presenter viewport must be a plain object");
    }
    const value = input;
    const hasScreen = Object.prototype.hasOwnProperty.call(value, "screen");
    const hasWidth = Object.prototype.hasOwnProperty.call(value, "width");
    const hasHeight = Object.prototype.hasOwnProperty.call(value, "height");
    if (hasWidth !== hasHeight ||
        Object.keys(value).length !==
            3 + (hasScreen ? 1 : 0) + (hasWidth ? 2 : 0) ||
        !["x", "y", "zoom"].every((key) => Object.prototype.hasOwnProperty.call(value, key))) {
        throw new Error("presenter viewport keys");
    }
    const { screen } = value;
    if (hasScreen &&
        (typeof screen !== "string" || !PRESENTER_SCREEN.test(screen))) {
        throw new Error("presenter viewport screen");
    }
    const { x, y, zoom } = value;
    if (typeof x !== "number" ||
        !Number.isFinite(x) ||
        x < VSM_PRESENTER_VIEWPORT_MIN ||
        x > VSM_PRESENTER_VIEWPORT_MAX ||
        typeof y !== "number" ||
        !Number.isFinite(y) ||
        y < VSM_PRESENTER_VIEWPORT_MIN ||
        y > VSM_PRESENTER_VIEWPORT_MAX ||
        typeof zoom !== "number" ||
        !Number.isFinite(zoom) ||
        zoom < VSM_PRESENTER_ZOOM_MIN ||
        zoom > VSM_PRESENTER_ZOOM_MAX) {
        throw new Error("presenter viewport bounds");
    }
    const { width, height } = value;
    if (hasWidth &&
        [width, height].some((size) => typeof size !== "number" ||
            !Number.isFinite(size) ||
            size <= 0 ||
            size > PRESENTER_AREA_MAX)) {
        throw new Error("presenter viewport area");
    }
    return Object.freeze({
        x,
        y,
        zoom,
        ...(hasScreen ? { screen: screen } : {}),
        ...(hasWidth ? { width: width, height: height } : {}),
    });
}
/** A V1-safe server announcement, followed by a client acknowledgement. */
export const VSM_PRESENCE_V2_ANNOUNCE = "playbookai:collab:vsm-presence-capability:2";
export const VSM_PRESENCE_V2_ACK = "playbookai:collab:vsm-presence-ack:2";
//# sourceMappingURL=canvas-awareness.js.map